module.exports = __webpack_public_path__ + "fdf25eef6963704b077809bf1ef7e542.MP3";